import { calculatePathControlPoints } from "./CalculatePathControlPoints"

// for every icon calculate all (including chained) links and their controlpoints
function CalculateLinkPathsPerIcon(data, iconPositions, connectionChains, circleR) {

  let linkPathsPerIcon = {};

  data.forEach(icon => {
    linkPathsPerIcon[icon.ID] = calculatePathLinks(data, connectionChains[icon.ID]['chainLinks'], icon.ID, iconPositions, circleR);
  });

  return linkPathsPerIcon;
}

function calculatePathLinks(data, links, icon, iconPositions, circleR){

  let linksPerCirclePosNeg = calcLinksPerCircle(data, links, iconPositions, icon);
  const linksPerCirclePos = thetaOrdering(iconPositions, linksPerCirclePosNeg['positiveTheta'], 'pos', icon);
  const linksPerCircleNeg = thetaOrdering(iconPositions, linksPerCirclePosNeg['negativeTheta'], 'neg', icon);

  const rPositionsPerCirclePos = calculateCircleRSteps(linksPerCirclePos);
  const rPositionsPerCircleNeg = calculateCircleRSteps(linksPerCircleNeg);


  let pathLinks = [];
  pathLinks = getPathLinks(data, pathLinks, linksPerCirclePos, rPositionsPerCirclePos, iconPositions, circleR)
  pathLinks = getPathLinks(data, pathLinks, linksPerCircleNeg, rPositionsPerCircleNeg, iconPositions, circleR)

  return pathLinks;
}


function calcLinksPerCircle(data, links, iconPositions, icon){
  //
  let linksPerCircle = {
    'positiveTheta':[[],[],[],[]],
    'negativeTheta':[[],[],[],[]]
  }

  links.forEach(link => {

    const icons = link.split('_to_');
    const typenr1 = data.filter(d => d.ID === icons[0])[0]['typenr'];
    const typenr2 = data.filter(d => d.ID === icons[1])[0]['typenr'];

    const circleID = determineCircleID(+typenr1, +typenr2);

    const startTheta = iconPositions[+icons[0]][1];
    let endTheta = iconPositions[+icons[1]][1];

    let theta = (+icons[0] === icon)
      ? calcThetaDiff(startTheta, endTheta)
      : calcThetaDiff(endTheta, startTheta)

    const sign = (Math.sign(theta) === 1)
      ? 'positiveTheta'
      : 'negativeTheta'

    linksPerCircle[sign][circleID].push(link)

  })


  return linksPerCircle;
}

function determineCircleID(typenr1, typenr2){
  let circleID = 1;
  if(typenr2 > typenr1){
    circleID = typenr1 + 1;
  }else{
    circleID = typenr1;
  }
  return circleID - 1;
}

function calcThetaDiff(startTheta, endTheta){
  let thetaDiff = endTheta - startTheta;
  if(thetaDiff > Math.PI){
    thetaDiff = thetaDiff - 2*Math.PI;
  }
  if(thetaDiff < -Math.PI){
    thetaDiff = thetaDiff + 2*Math.PI;
  }
  return thetaDiff;
}

function thetaOrdering(iconPositions, linksPerCircleSign, sign, icon){

  linksPerCircleSign.forEach((links, i) => {
    let thetas = [];
    links.forEach((link, i) => {
      const icons = link.split('_to_');
      let startIcon = +icons[0];
      let endIcon = +icons[1];
      if(startIcon !== icon){
        let startIcon = +icons[1];
        let endIcon = +icons[0];
      }
      const startTheta = iconPositions[startIcon][1];
      const endTheta = iconPositions[endIcon][1];
      const startR = iconPositions[startIcon][0];
      const endR = iconPositions[endIcon][0];

      // some hacky-ish code to make sure connections intersect as little as possible
      // let thetaDiff = (startIcon === icon)
      //   ? calcThetaDiff(startTheta, endTheta)
      //   : calcThetaDiff(endTheta, startTheta);

      let thetaDiff = calcThetaDiff(startTheta, endTheta)

      if(startR > endR){
        sign = Math.sign(thetaDiff)
        thetaDiff = sign * ( - Math.abs(thetaDiff) + 2*Math.PI);
      }
      thetas.push([link, thetaDiff]);
    });

    if(sign === 'pos'){
      thetas.sort((a, b) => a[1] < b[1])
    }else{
      thetas.sort((a, b) => a[1] > b[1])
    }

    linksPerCircleSign[i] = thetas.map(d => d[0]);

  });

  return linksPerCircleSign;
}

function calculateCircleRSteps(linksPerCircle){
  let rPositionsPerCircle = []
  for(let circleID=0;circleID<4;circleID++){
    let positions = [];
    const noOfLinks = linksPerCircle[circleID].length;
    const step = (noOfLinks < 5)
      ? 6
      : 25/noOfLinks;

    for(let i=0;i<noOfLinks;i++){
      positions.push((i - noOfLinks/2 + 1/2) * step)
    }

    rPositionsPerCircle.push(positions);
  }

  return rPositionsPerCircle;
}

function getPathLinks(data, pathLinks, linksPerCircle, rPositionsPerCircle, iconPositions, circleR){
  linksPerCircle.forEach((links_, circleID) => {
    links_.forEach((link, i) => {
      const icons = link.split('_to_');
      pathLinks.push({
        'link':link,
        'controlPoints':calculatePathControlPoints(data, +icons[0], +icons[1], iconPositions, circleR, rPositionsPerCircle[circleID][i])
      });
    });
  });

  return pathLinks;
}




export default CalculateLinkPathsPerIcon;
